/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { Logger } from "cms/utils/log/logger";

const useFetchModel = () => {
    const fetchModel = async (token, guid) => {
        const response = await SimpliCityAdminSDK.model.findOne(token, guid);
        Logger.info(`Get Model: ${guid}, [${response?.title}]`);
        // Logger.debug(response)
        // Logger.flush()
        return response;
    };
    return fetchModel;
};

export default useFetchModel;
